import {NICEStudioScript} from './NICE_StudioScript.model';
import {NICESkill} from './NICE_Skill.model';
import {DateTime} from 'luxon';

export class NICEHoursOfOperation
{
    profileId: number;
    profileName: string;
    description: string;
    notes: string;
    overrideBranch: string;
    overrideExpirationDate: string;
    lastUpdateTime: string;
    days: [NICEHoursOfOperationDay];
    // holidays: [NICEHoursOfOperationDay];
    holidays: [any];
    skills: [NICESkill];
    scripts: [NICEStudioScript];

    constructor(hoursProfileResponse?)
    {
        if (hoursProfileResponse != null) {
            this.profileId = +hoursProfileResponse.profileId;
            this.profileName = hoursProfileResponse.profileName;
            this.description = hoursProfileResponse.description;
            this.notes = hoursProfileResponse.notes;
            this.overrideBranch = hoursProfileResponse.overrideBranch;
            this.overrideExpirationDate = hoursProfileResponse.overrideExpirationDate;
            this.lastUpdateTime = hoursProfileResponse.lastUpdateTime;
            this.days = hoursProfileResponse.days.map(data => new NICEHoursOfOperationDay(data));
            if (hoursProfileResponse.holidays) {
                this.holidays = hoursProfileResponse.holidays.map(data => new NICEHoursOfOperationDay(data));
            }else{
                this.holidays = [new NICEHoursOfOperationAddDay()];
                this.holidays.splice(0, 1);
            }
            if (hoursProfileResponse.skills) {
                this.skills = hoursProfileResponse.skills.map(data => new NICESkill(data));
            }
            if (hoursProfileResponse.scripts) {
                this.scripts = hoursProfileResponse.scripts.map(data => new NICEStudioScript(data));
            }
        }
    }
}


export class NICEHoursOfOperationDay {
    name: string;
    day: string;
    date: string; // "1/1/2020 12:00:00 AM"
    openTime: string;
    closeTime: string;
    hasAdditionalHours: boolean;
    additionalOpenTime: string;
    additionalCloseTime: string;
    isClosedAllDay: boolean;
    constructor(niceHoliday?)
    {
        if (niceHoliday != null) {
            this.name = niceHoliday.name;
            if ( niceHoliday.day !== undefined) {
                this.day = niceHoliday.day;
            }else{
                this.day = DateTime.fromISO(niceHoliday.date).weekdayLong;
            }
            this.date = niceHoliday.date;
            this.openTime = niceHoliday.openTime;
            this.closeTime = niceHoliday.closeTime;
            this.hasAdditionalHours = niceHoliday.hasAdditionalHours === 'True' || niceHoliday.hasAdditionalHours === true;
            this.additionalOpenTime = niceHoliday.additionalOpenTime;
            this.additionalCloseTime = niceHoliday.additionalCloseTime;
            this.isClosedAllDay = niceHoliday.isClosedAllDay === 'True' || niceHoliday.isClosedAllDay === true;
        }else{
            this.name = '';
            this.day = '';
            this.date = '';
            this.openTime = '00:00:00';
            this.closeTime = '23:59:00';
            this.hasAdditionalHours = false;
            this.additionalOpenTime = '00:00:00';
            this.additionalCloseTime = '23:59:00';
            this.isClosedAllDay = false;

        }
    }
}
export class NICEHoursOfOperationAddDay {
    name: string;
    holidayName: string;
    day: string;
    date: string; // "1/1/2020 12:00:00 AM"
    openTime: string;
    closeTime: string;
    hasAdditionalHours: boolean;
    additionalOpenTime: string;
    additionalCloseTime: string;
    isClosedAllDay: boolean;
    constructor(niceHoliday?)
    {
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        if (niceHoliday != null) {
            this.name = niceHoliday.name;
            this.holidayName = niceHoliday.name;
            this.day = DateTime.fromISO(niceHoliday.date).weekdayLong;
            this.date = niceHoliday.date;
            this.openTime = niceHoliday.openTime;
            this.closeTime = niceHoliday.closeTime;
            this.hasAdditionalHours = niceHoliday.hasAdditionalHours === 'True' || niceHoliday.hasAdditionalHours === true;
            this.additionalOpenTime = niceHoliday.additionalOpenTime;
            this.additionalCloseTime = niceHoliday.additionalCloseTime;
            this.isClosedAllDay = niceHoliday.isClosedAllDay === 'True' || niceHoliday.isClosedAllDay === true;
        }else{
            this.name = '';
            this.holidayName = '';
            this.day = '';
            this.date = '';
            this.openTime = '00:00:00';
            this.closeTime = '23:59:00';
            this.hasAdditionalHours = false;
            this.additionalOpenTime = '00:00:00';
            this.additionalCloseTime = '23:59:00';
            this.isClosedAllDay = false;

        }
    }
}
export class NICEHoursOfOperationDeleteDay {
//    name: string;
//    holidayName: string;
    // day: string;
    // date: string; // "1/1/2020 12:00:00 AM"
    // openTime: string;
    // closeTime: string;
    // hasAdditionalHours: boolean;
    // additionalOpenTime: string;
    // additionalCloseTime: string;
    // isClosedAllDay: boolean;
    deleteHoliday: boolean;
    deleteHolidayDate: string;

    constructor(niceHoliday?)
    {
        if (niceHoliday != null) {
//            this.name = niceHoliday.name;
//            this.holidayName = niceHoliday.name;
//            this.day = niceHoliday.day;
//            this.date = niceHoliday.date;
//            this.date = '01/03/2003';
//            this.openTime = niceHoliday.openTime;
//            this.closeTime = niceHoliday.closeTime;
//            this.hasAdditionalHours = niceHoliday.hasAdditionalHours === 'True' || niceHoliday.hasAdditionalHours === true;
//            this.additionalOpenTime = niceHoliday.additionalOpenTime;
//            this.additionalCloseTime = niceHoliday.additionalCloseTime;
//            this.isClosedAllDay = niceHoliday.isClosedAllDay === 'True' || niceHoliday.isClosedAllDay === true;
           this.deleteHoliday = true;
           this.deleteHolidayDate = niceHoliday.date;
        }else{
 // //           this.name = '';
 // //           this.holidayName = '';
 //            this.day = '';
 // //           this.date = '';
 //            this.openTime = '00:00:00';
 //            this.closeTime = '23:59:00';
 //            this.hasAdditionalHours = false;
 //            this.additionalOpenTime = '00:00:00';
 //            this.additionalCloseTime = '23:59:00';
 //            this.isClosedAllDay = false;

        }
    }
}
